export default __webpack_public_path__ + "static/media/date.176aa15b.svg";